/** The TypeScript copy of the backend's normalize_asset_tag, used to find an
 *  item's tag in the cached redundancy sets. The shared cases in the test beside
 *  this file and in backend/services/test_redundancy_set_service.py keep the two equal. */
export function normalizeAssetTag(tag: string | null | undefined): string {
  return (tag ?? '').trim().toUpperCase().replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '');
}
